function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.80952 1.38098H7.52381C5.41987 1.38098 3.71428 3.08656 3.71428 5.19051V7.47622H1.42857V10.5238H3.71428V16.6191H6.7619V10.5238H9.04762L9.80952 7.47622H6.7619V5.19051C6.7619 4.76972 7.10302 4.4286 7.52381 4.4286H9.80952V1.38098Z",
  stroke: "#7D86A1",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.ecea43e3.svg";
export { ForwardRef as ReactComponent };